define([
    'jquery',
    'Handlebars',
    'handlebars-core',
    "shared.main.screen",
], function ($, Handlebars, HandlebarsCore, screenSize) {

// Name the plugin
    var PLUGIN_IDENTIFIER = 'fullscreenLauncher',
        DEBUG = false;

// Create the function that will be bound to JQuery
    var vfdpPlugin = function (element, options) {
        this.element = element;
        this.options = options;
    };

// Flag to handle pinch to zoom gesture
    var pinchToZoomFlag = false,
        tapped = false,
        pdpSwiperFullscreenEnabled = WCS_CONFIG.get('PDP::pdpSwiperFullscreenEnabled') || false;

// Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
            template: 'html.viewer-swatch-cta.viewer-swatch-cta',
            targetContainer: '.ZoomView-ViewerWrapper > .s7innercontainer > .s7zoomview',
            ctaContainer: '.viewer-swatch-cta-container',
            ctaEnabledClass: 'viewer-swatch-bottom-cta-enabled',
            currentDataOptions: {},
            logoTitle: 'test',
            modal: '#modal-images-gallery',
            mode: 'flat', // Fullscreen mode currently 'flat'(default) or 'carousel'
        },

        /**
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function () {
            var self = this;

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER + 'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );

            // Initialize events
            self.events();

            // Do any DOM manipulation or other setup
            self._build();
            // Allow JQuery-style chaining of the plugin

            self.loadAndCompileTemplate().done(function () {
                self.render(self.config);
            });


            return self;
        },

        /**
         * Modifies the DOM to support layout requirements
         **/
        _build: function () {
            var self = this;

            window.addEventListener('init.viewer.complete.ready', function(event) {
                return self.loadAndCompileTemplate().done(function () {
                    self.render(self.config);
                });
            }, false);

            // do on-init DOM modifications here
        },

        /**
         * render()
         * Renders our Handlebars template.
         * @param {Object} data - the data you wish to render
         */
        render: function (data) {
            var self = this;
            self.$targetContainer = $(self.config.targetContainer);
            self.$targetContainer.addClass(self.config.ctaEnabledClass);

            if (self.config.mode === 'carousel') {
                var $scene7Container = $('.vfdp-s7-viewer > .s7container');
                $scene7Container.append(self.compiledTemplate(data));
                $scene7Container.find(self.config.ctaContainer).off('click');
                $scene7Container.find(self.config.ctaContainer).on('click', function(event) {
                    event.stopImmediatePropagation();
                    self.initCycleAndLaunchModal();
                });
            } else {
                if ( WCS_CONFIG.get('PDP::pdpSwiperEnabledMobile') ) {
                    self.$targetContainer.empty();
                    self.$targetContainer.append(self.compiledTemplate(data));
                    if (self.$targetContainer.hasClass('fullscreen-container')) {
                        self.$buttonContainer = $('.fullscreen-container')[0];
                    } else {
                        self.$buttonContainer = $('.swiper-fullscreenmobile-hero-container')[0];
                    }
                } else {
                    self.$targetContainer.append(self.compiledTemplate(data));
                    self.$buttonContainer = $('.vfdp-s7-viewer > .s7container')[0];
                }
                // Clean event listener before create a new one
                if ( self.$buttonContainer !== undefined ) {
                    self.$buttonContainer.removeEventListener('click', self.launchModal.bind(self));
                    self.$buttonContainer.addEventListener('click', self.launchModal.bind(self));
                }
            }
            self.$componentContainer = $(self.config.ctaContainer);
        },

        /**
         * Binds plugin events
         **/
        events: function () {
            var self = this;

            // Re-render after swatch changes
            $.pubsub('subscribe', 'product-form.product-viewer.swatch.click.complete', function(event, data) {
                self.render(self.config);
            });

            // Re-render when changing screen size
            $.pubsub('subscribe','window.resize.breakpoint',function(event, data) {
                if(screenSize.size() == 'small') {
                    self.render(self.config);
                }
            });

            if (self.config.zoom && self.config.zoom.enabled == "true" ) {
                self.zoomEvents();
            }
        },

        zoomEvents: function() {
            var self = this,
                $fullscreenContainer = $(self.config.modal +' div');

            self.zoom = {},
            self.zoom.start = {};

            $fullscreenContainer.on('touchstart', function(event) {
                if (event.touches.length == 2) {
                    pinchToZoomFlag = true;
                    tapped=false;
                    $(event.currentTarget).find('picture img').addClass('pinch-to-zooming');
                    // Calculate where the fingers have started on the X and Y axis
                    self.zoom.startx = (event.touches[0].pageX + event.touches[1].pageX) / 2;
                    self.zoom.starty = (event.touches[0].pageY + event.touches[1].pageY) / 2;
                    self.zoom.start.distance = self.distance(event);
                }
                else if (!tapped){ //if tap is not set, set up single tap
                    tapped=setTimeout(function(){
                    tapped=false;
                    },300);   //wait 300ms then run single click code
                } else {    //tapped within 300ms of last tap. double tap
                    event.preventDefault();
                    clearTimeout(tapped); //stop single tap callback
                    $(event.currentTarget).find('picture img').css('transform','');
                    $(event.currentTarget).find('picture img').css('-webkit-transform','');
                    self.zoomImage(event);
                    tapped=false;
                }
            });

            $fullscreenContainer.on('touchmove', function(event) {
                if (pinchToZoomFlag && event.touches.length == 2) {
                    event.preventDefault();
                    var scale;
                    if (event.scale) {
                        scale = event.scale;
                    } else {
                        var deltaDistance = self.distance(event);
                        scale = deltaDistance / self.zoom.start.distance;
                    }
                    self.zoom.imageElementScale = Math.min(scale, self.config.zoom.maxScale);

                    if ($(event.currentTarget).find('.pinch-to-zooming').length > 0 && self.zoom.currentScale) { //prevent reset scale of image to 1
                        if (self.zoom.imageElementScale > 1) {
                            self.zoom.imageElementScale = (self.zoom.currentScale) + (self.zoom.imageElementScale - 1); //zoom-in
                        } else {
                            self.zoom.imageElementScale = Math.max((self.zoom.currentScale) - (1 - self.zoom.imageElementScale),1); //zoom-out
                        }
                    } else if (!self.zoom.currentScale) {
                        self.zoom.imageElementScale = Math.max(self.zoom.imageElementScale,1);
                    }
                    self.zoom.roundedNewScale = Math.round(self.zoom.imageElementScale,2);

                    var transform = 'scale('+self.zoom.imageElementScale+')';
                    $(event.currentTarget).find('picture img').css('transform',transform);
                    $(event.currentTarget).find('picture img').css('-webkit-transform',transform);
                    self.scrollToPosition(event);
                }
            });

            $fullscreenContainer.on('touchend', function(event) {
                if (pinchToZoomFlag) {
                    if ( (self.zoom.roundedLastScale !== undefined && (self.zoom.roundedNewScale > (self.zoom.roundedLastScale + self.config.zoom.nextRes) || self.zoom.roundedLastScale > (self.zoom.roundedNewScale + self.config.zoom.nextRes))) || self.zoom.roundedLastScale == undefined) {
                        self.zoom.roundedLastScale = self.zoom.roundedNewScale;
                        self.updateImageResolution($(event.currentTarget).find('picture img'),self.zoom.roundedLastScale,"touch");
                    }
                    pinchToZoomFlag = false;
                    self.zoom.currentScale = self.zoom.imageElementScale;
                    $(event.currentTarget).find('picture img').removeClass('pinch-to-zooming');
                }
            });
        },

        distance: function(event) {
            return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
        },

        scrollToPosition: function(event) {
            var scrollableDivJ = $(event.currentTarget); //scroll to max
            scrollableDivJ.scrollLeft("1000000");
            scrollableDivJ.scrollTop("1000000");
            var img = $(event.currentTarget).find('img');

            var clientWidth = img[0].clientWidth || $(event.currentTarget).width(),
            clientHeight = img[0].clientHeight || $(event.currentTarget).height(),
            clickX = event.touches[0].clientX,
            clickY = event.touches[0].clientY;

            if( clickX <= 0 && clickY <= 0) {
                // if zero set the middle of the screen
                clickX = clientWidth / 2;
                clickY = clientHeight / 2;
            }
            var startingPercentageWidth = clickX * 100 / clientWidth,
                startingPercentageHeight = clickY * 100 / clientHeight,
                zoomedScrollLeftPosition = scrollableDivJ[0].scrollLeft * startingPercentageWidth / 100,
                zoomedScrollTopPosition = scrollableDivJ[0].scrollTop * startingPercentageHeight / 100;
            scrollableDivJ.scrollLeft(zoomedScrollLeftPosition);
            scrollableDivJ.scrollTop(zoomedScrollTopPosition);
        },

        updateImageResolution: function($selector,scale,fromName) {
            var self = this,
                imageUrl = new URL($selector.attr('src'));
            if (self.zoom.originalWidth == undefined && self.zoom.originalHeight == undefined) {
                self.zoom.originalWidth = (imageUrl.searchParams.get('wid'));
                self.zoom.originalHeight = (imageUrl.searchParams.get('hei'));
            }
            var zoomMultiplier = self.config.zoom.multiplier;
            if ( scale <= 1 || fromName == "click") { //avoiding downgrade image scenarios
                zoomMultiplier = 1;
            } else if ( scale > self.config.zoom.maxScale ) {
                scale = self.config.zoom.maxScale;
            }
            var newWidth = Math.round(((self.zoom.originalWidth * scale ) * zoomMultiplier),1),
                newHeight = Math.round(((self.zoom.originalHeight* scale ) * zoomMultiplier),1);
            if ( newWidth > self.config.zoom.maxRes || newHeight > self.config.zoom.maxRes ) {
                newHeight = self.config.zoom.maxRes;
                newWidth = self.config.zoom.maxRes;
            } else if (newWidth < self.zoom.originalWidth || newHeight < self.zoom.originalHeight) {
                    newWidth = self.zoom.originalWidth;
                    newHeight = self.zoom.originalHeight;
            }
            imageUrl.searchParams.set('wid',newWidth);
            imageUrl.searchParams.set('hei',newHeight);
            $selector.attr('src',decodeURIComponent(imageUrl));
            $selector.attr('srcset',decodeURIComponent(imageUrl));
        },

        zoomImage: function(event) {
            var self = this;
            if ($(event.currentTarget).find('picture').hasClass('zoomed')) {
                self.updateImageResolution($(event.currentTarget).find('.zoomed img'),1,"click");
                $(event.currentTarget).find('picture').removeClass('zoomed');
                $(event.currentTarget).attr('style','');
            } else {
                $(event.currentTarget).find('picture').addClass('zoomed');
                self.updateImageResolution($(event.currentTarget).find('.zoomed img'),self.config.zoom.maxScale,"click");
                $(event.currentTarget).find('.zoomed img').css('transform','scale('+(self.config.zoom.maxScale)+')');
                self.scrollToPosition(event);
            }
        },

        launchModal: function(event) {
            event.stopImmediatePropagation();
            var self = this;

            var offset = self.$targetContainer.offset();
            var x = event.x - offset.left;

            var element = self.$componentContainer[0];

            if (x > element.offsetLeft && x < element.offsetLeft + element.offsetWidth || self.$targetContainer.hasClass('fullscreen-container')) {
                var $modal = $('.reveal-overlay > ' + self.config.modal);
                $modal.closest('.reveal-overlay').addClass('fullscreen-launcher-overlay');
                if (pdpSwiperFullscreenEnabled) {
                    $modal.closest('.reveal-overlay').addClass('swiper-layout')
                    $modal.addClass('swiper-wrapper')
                    $modal.find('div').addClass('swiper-slide');
                    $('.swiper-slide').each(function() {
                        var $zoomContainer = $('<div class="swiper-zoom-container"></div>');
                        $(this).children().appendTo($zoomContainer);
                        $(this).append($zoomContainer);
                    });
                    $.pubsub('publish','swiperViewer.INIT_FULLSCREEN');
                }
                var $newModalContent = $('.mol-media-gallery > ' + self.config.modal);
                // Check to see if there is new content after swatch changes
                if($newModalContent.length > 0) {
                    var newContents = $newModalContent.children();
                    if (newContents.length > 0) {
                        // Replace old content with new one
                        $modal.empty().append(newContents.clone());
                    }
                }

                $modal.foundation('open');
            }
        },

        getClickedImageIndex: function() {
            var $dotIndicators = $('.vfdp-s7-viewer > .s7container .s7dot');
            var imageIndex = 0;

            if ($dotIndicators) {
                for (var index = 0; index < $dotIndicators.length; index+=1) {
                    if ($($dotIndicators[index]).attr('state') === 'selected') {
                        imageIndex = index;
                        break;
                    }
                }
            }

            return imageIndex;
        },

        initCycleAndLaunchModal: function() {
            if (DEBUG) console.log('initCycleAndLaunchModal');
            var self = this;

            var $modal = $('.reveal-overlay > ' + self.config.modal);
            $modal.closest('.reveal-overlay').addClass('fullscreen-launcher-overlay').addClass('fullscreen-launcher-overlay-carousel');
            var $newModalContent = $('.mol-media-gallery > ' + self.config.modal);
            // Check to see if there is new content after swatch changes
            if($newModalContent.length > 0) {
                var newContents = $newModalContent.children();
                if (newContents.length > 0) {
                    // Replace old content with new one
                    $modal.empty().append(newContents.clone());
                    // Remove the content to avoid reinitializing the contents on next launch
                    newContents.remove();
                }
            }

            var $slideshow = $modal.find('.product-image-carousel');
            var imageIndex = self.getClickedImageIndex();

            // Check if cycle2 initialized for the modal and switch to current image viewed
            if ($slideshow.hasClass('active')) {
                $slideshow.cycle('goto', imageIndex);
                $modal.foundation('open');
            } else {
                require([
                    'cycle'
                ],
                function(cycle) {
                    var settings = {
                        fx: 'fadeout',
                        maxZ: 10,
                        pager: '.pager-container',
                        pagerActiveClass: 'active',
                        slides: '> .carousel-images',
                        swipe: true,
                        timeout: 0,
                    };

                    $slideshow.cycle(settings);
                    if (imageIndex > 0) {
                        $slideshow.cycle('goto', imageIndex);
                    }
                    $slideshow.addClass('active');
                    $modal.foundation('open');
                });
            }
        }
};

// Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;
    vfdpPlugin.prototype = $.extend({}, HandlebarsCore, vfdpPlugin.prototype);

// Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function (options) {
        return this.each(function () {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if (!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };

});
